import { O365AuditWebComponent } from './component/O365AuditWebComponent';
import { WEB_COMPONENT_SENSOR_O365_AUDIT } from '../../../webcomponents.constants';

export { O365AuditWebComponent };

window.customElements.define(WEB_COMPONENT_SENSOR_O365_AUDIT, O365AuditWebComponent);
